import React from 'react';
import { motion } from 'framer-motion';
import { HerbSprig, LeafCluster } from './HealingIcons';
export const Section = ({
  children,
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6
}} className={`${`py-12 md:py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full bg-transparent ${className}`} pt-[4px]`} data-id="element-364" data-mp="136kr3ed254tt">
    {children}
  </motion.section>;
export const LeafDivider = ({
  className = ''
}: {
  className?: string;
}) => <div className={`flex items-center justify-center gap-3 my-8 ${className}`} aria-hidden="true" data-id="element-365" data-mp="khnwtahnucbl">
    <span className="h-px w-16 md:w-28 bg-gradient-to-r from-transparent to-brand-greenLight/60" data-id="element-366" data-mp="pcl2c7fqe3jq" />
    <LeafCluster className="w-4 h-4 opacity-70" color="#6FA524" data-id="element-367" data-mp="1vwueygu6rosv" />
    <HerbSprig className="w-5 h-5 opacity-80" color="#2F6B34" data-id="element-368" data-mp="20srs6ea5kf1f" />
    <LeafCluster className="w-4 h-4 opacity-70" color="#C9A961" style={{
    transform: 'scaleX(-1)'
  }} data-id="element-369" data-mp="39jr8qlidff45" />
    <span className="h-px w-16 md:w-28 bg-gradient-to-l from-transparent to-brand-greenLight/60" data-id="element-370" data-mp="34kemo2zbqc2m" />
  </div>;
export const CTAButton = ({
  children,
  href,
  className = '',
  fullWidth = false,
  variant = 'purple',
  onClick
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
  onClick?: () => void;
}) => {
  const bgClass = variant === 'purple' ? 'purple-gradient-bg' : 'gold-gradient-bg';
  const shadowClass = variant === 'purple' ? 'shadow-[0_0_20px_rgba(47,107,52,0.35)] hover:shadow-[0_0_30px_rgba(111,165,36,0.55)]' : 'shadow-[0_0_20px_rgba(201,169,97,0.3)] hover:shadow-[0_0_30px_rgba(201,169,97,0.5)]';
  const classes = `inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white ${bgClass} rounded-full ${shadowClass} transition-shadow duration-300 cursor-pointer ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <motion.a href={href} onClick={onClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={classes} data-id="element-371" data-mp="1t6dodkknzefd">
        {children}
      </motion.a>;
  }
  return <motion.a href="#pricing" onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} data-id="element-372" data-mp="1jb2izsv5bjka">
      {children}
    </motion.a>;
};